export const createTooltip = (text, type = 'info') => {
	const tooltip = document.createElement('div');
	tooltip.className = `tooltip tooltip--${type}`;
	tooltip.setAttribute('role', 'tooltip');
	if (type === 'info') {
		tooltip.setAttribute('data-color-scheme', 'highlight');
	}
	tooltip.innerHTML = `<div data-popper-arrow></div>${text}`;
	document.body.appendChild(tooltip);
	return tooltip;
};
